//vender
import React, { Component } from "react";
import { connect } from "react-redux";
import { HOST_URL } from "../../constants";

//models
import { myBag } from "../../models";

//i18n
import { Translation } from "react-i18next";

class Mybag extends Component {
  remove = async item => {
    const {
      removeMyBagItem,
      IsDeliveryMode,
      storeId,
      addressId,
      fetchMyBag,
      myBagData
    } = this.props;
    const deliveryId = !IsDeliveryMode
      ? { addressId: addressId }
      : { storeId: storeId };

    async function fetchDeliveries(deliveryId) {
      await fetch(`${HOST_URL}/shopping/v1/compositions/deliveries`, {
        credentials: "include",
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify(deliveryId)
      });
    }
    await removeMyBagItem(item, myBagData);
    if (deliveryId.hasOwnProperty("addressId")) {
      if (deliveryId.addressId !== "") {
        fetchDeliveries(deliveryId);
      }
    } else if (deliveryId.hasOwnProperty("storeId")) {
      if (deliveryId.storeId !== "") {
        fetchDeliveries(deliveryId);
      }
    }
  };

  render() {
    const { item } = this.props;
    const pdt = {
      imageUrl: item.information.imageUrl,
      prodname1: item.information.prodname1,
      prodname2: item.information.prodname2,
      information: item.information,
      data: item.information.data,
      returnable: item.information.returnable,
      origPrice: item.information.origPrice,
      discountAmount: item.discountAmount,
      discountName: item.discountName,
      code: item.information.code,
      productDetailUrl: item.information.productDetailUrl,
      returnCondition: item.information.returnCondition
    };
    return (
      <>
        <div className="pdt_wrap row no-gutters">
          {/* <a href={` /eshop-hk${pdt.productDetailUrl}`}> */}
          <div
            style={{ cursor: "pointer" }}
            className="col-3 thm_col_wrap"
            onClick={() => {
              window.location = `/eshop-hk${pdt.productDetailUrl}`;
            }}
          >
            <img src={pdt.imageUrl} alt="" />
          </div>
          <div
            style={{ cursor: "pointer" }}
            className="col-5 col-md-4 details_col_wrap"
            onClick={() => {
              window.location = `/eshop-hk${pdt.productDetailUrl}`;
            }}
          >
            <div className="name_wrap">
              <div className="collectionName">{pdt.prodname1}</div>
              <div className="name">{pdt.prodname2}</div>
            </div>

            <div className="details_wrap">
              <div>
                <Translation>{t => t("checkout.modelNum")}</Translation>
                {pdt.code}
              </div>
              {pdt.data.map((item, index) => {
                return (
                  <div key={index}>
                    {item.name} : {item.value}
                  </div>
                );
              })}
              {/* <Translation>{t => t("checkout.qut")}</Translation>
              {item.quantity} */}
            </div>
            <div className="services">{pdt.returnCondition}</div>
          </div>
          {/* </a> */}
          <div className="col-0 col-md-2 notes notes_col_wrap">
            {item.discountName}
          </div>
          <div className="col-4 col-md-3 price_col_wrap">
            {pdt.origPrice !== pdt.discountAmount ? (
              <>
                <div className="price">{pdt.discountAmount}</div>
                <div className="originalPrice_wrap">
                  <div className="price">{pdt.origPrice}</div>
                </div>
              </>
            ) : (
              <div className="price">{pdt.origPrice}</div>
            )}

            <div className="notes notes_wrap_m">{pdt.discountName}</div>
          </div>

          <button
            type="button"
            className="closeBtn"
            aria-label="Remove item"
            onClick={this.remove.bind(this, item)}
            disabled={this.props.isLoading}
          >
            <span className="stroke" aria-hidden="true"></span>
            <span className="stroke" aria-hidden="true"></span>
          </button>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    myBagData: state.myBag.myBagData,
    getMyBagSuccessfully: state.myBag.getMyBagSuccessfully,
    isLoading: state.loading.isLoading
  };
};

const mapDispatchToProps = () => {
  return {
    removeMyBagItem: (item, myBagData) =>
      myBag.actions.removeMyBagItem(item, myBagData),
    fetchMyBag: () => myBag.actions.fetchMyBag()
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Mybag);
